import React from 'react';
import { formatShortDate, patientSummary } from '../utils/format';
import UiIcon from './UiIcon';
import './PhoneHomeScreen.css';

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
  'October', 'November', 'December'];

// The app's greeting and summary (kabilah-react-native logic/dates.ts greeting,
// formatLongDate and logic/report.ts).
export function greeting(firstName, date = new Date()) {
  const hour = date.getHours();
  const base = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  return firstName ? `${base}, ${firstName}!` : `${base}!`;
}

export function homeSummary(count, date = new Date()) {
  const longDate = `${WEEKDAYS[date.getDay()]}, ${MONTHS[date.getMonth()]} ${date.getDate()}`;
  return [`It's ${longDate}.`, `You have ${count} current patient${count === 1 ? '' : 's'}.`];
}

const newestFirst = (a, b) => String(b.updatedAt || '').localeCompare(String(a.updatedAt || ''));

// A nurse's home screen in the Kabilah app, for PhoneFrame: the greeting, how
// many patients they have, and a card per patient. Tapping a card calls
// onOpen(sheet) (PhoneApp opens it in the same phone). The settings, QR and
// Add buttons are for the look only.
const PhoneHomeScreen = ({ firstName, sheets, onOpen, blankText = 'Patients this nurse adds in the app will show up here.' }) => {
  const [line1, line2] = homeSummary(sheets.length);
  const readOnly = { 'aria-hidden': true, title: 'This is done in the Aren app' };
  return (
    <>
      <div className="app-nav">
        <span className="app-circle-button app-circle-muted" {...readOnly}><UiIcon name="settings" /></span>
        <span className="app-circle-button app-circle-muted" {...readOnly}><UiIcon name="qr-code" /></span>
      </div>
      <header className="home-header">
        <h2 className="home-greeting">{greeting(firstName)}</h2>
        <p className="home-summary">{line1}<br />{line2}</p>
      </header>
      <div className="app-scroll">
        {sheets.length === 0 ? (
          <div className="home-blank">
            <p className="home-blank-title">No current patients</p>
            <p className="home-blank-text">{blankText}</p>
          </div>
        ) : (
          <div className="home-list">
            {[...sheets].sort(newestFirst).map((sheet) => (
              <button key={sheet.reportId} type="button" className="home-card" onClick={() => onOpen(sheet)}>
                <span className="home-card-date">{formatShortDate(sheet.updatedAt)}</span>
                <span className="home-card-name">{sheet.name || 'Patient Name'}</span>
                <span className="home-card-description">{patientSummary(sheet) || 'Gender, Age, Room Number, Admitted Date'}</span>
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="home-footer" {...readOnly}>
        <span className="home-add"><UiIcon name="add" size={22} />Add New Patient</span>
      </div>
    </>
  );
};

export default PhoneHomeScreen;
